export function getActionPermissions(role) {
  const normalized = String(role || "").trim().toLowerCase();

  const base = {
    canView: true,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  };

  switch (normalized) {
    case "superadmin":
      return {
        ...base,
        canAdd: true,
        canEdit: true,
        canDelete: true,
      };

    case "manager":
      return {
        ...base,
        canAdd: true,
        canEdit: true,
      };

    case "admin":
      return {
        ...base,
        canAdd: true,
      };

    default:
      return base;
  }
}
